import type { IconType } from '../types/SharedIconProps';
import type { Status } from '../types/Status';

const STATUS_ICONS: Record<Status, IconType> = {
  cautious: 'warning-exclamation',
  critical: 'warning-exclamation',
  informational: 'info',
  neutral: 'info',
  positive: 'check-circle',
};

export const getStatusIcon = (status: Status): IconType => STATUS_ICONS[status];
